import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { SectionContainerComponent } from './sectionContainer/section-container/section-container.component';
import { OrganisationSelectorComponent } from './shared/component/organisation-selector/organisation-selector.component';
import { OrganisationGuard } from './shared/guard/organisation-guard/organisation.guard';
import { SessionExpiredInfoComponent } from './shared/component/session-expired-info/session-expired-info.component';
import { SessionExpiredGuard } from './shared/guard/sessionexpired-guard/sessionexpired.guard';

const routes: Routes = [
  { path: 'login', component: OrganisationSelectorComponent, canActivate: [MsalGuard] },
  { path: '', component: SectionContainerComponent, canActivate: [OrganisationGuard, SessionExpiredGuard] },
  { path: 'sessionexpired', component: SessionExpiredInfoComponent },
  { path: '**', redirectTo: '' } // default route
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
